import React from 'react';
import { useManagementMode } from '@/hooks/useManagementMode';
import { ManagementModeSelection } from '@/components/onboarding/ManagementModeSelection';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

interface OnboardingGuardProps {
  children: React.ReactNode;
}

export const OnboardingGuard: React.FC<OnboardingGuardProps> = ({ children }) => {
  const { hasMode, loading } = useManagementMode();

  // Pendant le loading, on affiche le spinner mais on n'affiche jamais la sélection de mode
  // pour éviter le flicker lors du rechargement
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // Seulement si on a fini de charger ET qu'on n'a pas de mode, on affiche la sélection
  if (!loading && !hasMode) {
    return <ManagementModeSelection />;
  }

  return <>{children}</>;
};